import type { FC } from "react";

import { BlogItem } from "@jti/ui/components/BlogListing/BlogItem";
import { CardGeneric } from "@jti/ui/components/CardGeneric";
import { IconBannerCard } from "@jti/ui/components/IconBannerCard";

import styles from "./Overview.module.scss";

type Item = {
  imageUrl: string;
  title: string;
  description?: string;
};

export type OverviewProps = {
  variant: "earnPoints" | "clubOverview";
  title?: string;
  subtitle?: string;
  secondarySubtitle?: string;
  items: Item[];
};

export const Overview: FC<OverviewProps> = ({
  variant = "clubOverview",
  items = [],
  title,
  subtitle,
  secondarySubtitle,
}) => {
  const overviewItems = (
    <div data-testid="overviewItems" className={styles.items}>
      {items.map(({ imageUrl, title, description }) => {
        return variant === "clubOverview" ? (
          <IconBannerCard
            key={title}
            title={title}
            description={description}
            customIcon={<img src={imageUrl} alt={title} className={styles.customIcon} />}
            isBorderVisible={true}
          />
        ) : (
          <BlogItem
            key={title}
            title={description ?? ""}
            isLink={false}
            isFeatured={false}
            subtitle={title}
            image={{ smallReference: imageUrl, mediumReference: imageUrl, largeReference: imageUrl, altText: title }}
          />
        );
      })}
    </div>
  );

  if (variant === "clubOverview") {
    return <div data-testid="overview-clubOverview">{overviewItems}</div>;
  }

  return (
    <CardGeneric
      data-testid="overview-earnPoints"
      title={title}
      secondaryTitle={subtitle}
      description={secondarySubtitle}
    >
      {overviewItems}
    </CardGeneric>
  );
};
